<template>
  <div>
  <b-row>
    <b-col md="8" class="my-1">
      <h1>Concesiones</h1>
    </b-col>
    <b-col md="4" class="text-right my-1">
      <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
        <b-input-group>
          <b-form-input v-model="filter" class="form-control" placeholder="Buscar concesión"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label-cols-sm="3" class="mb-0">
        <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getAllConceciones"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
      class="table table-sm"
    >
      <!-- template v-slot:cell(concesionNumber)="row">
        <b-col style="width: 120px;">{{ row.concesionNumber }}</b-col>
      </!-->
      <template v-slot:cell(motivos)="row">
        <b-button class="btn-sm" v-if="!row.item.active" variant="outline-primary" @click="showEvidence(row.item)">Visualizar evidencia</b-button>
      </template>
      <template v-slot:cell(active)='row' v-if="this.$store.state.user.role == 'Super Admin'" class="pt-2">
        <b-button variant="danger_outline" class="text-center" @click="$event => showConfirmPayment(row.item)" ><i class="fa-sharp fa-solid fa-bank text-danger fa-2xs mr-2"></i> Aprobar pago</b-button>
      </template>
      <template v-slot:cell(acciones)="row" v-if="this.$store.state.user.role != 'AUTORIDADES - STCH'">
        <b-dropdown id="dropdown-1" variant="btn-link border-0" class="float-right pb-0" dropleft no-caret>
          <template #button-content>
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </template>
          <b-dropdown-item><b-badge pill class="w-100 pt-2 pb-2" :class="row.item.paidOut === 1 ? 'bg-success' : 'bg-danger'">{{row.item.paidOut === 1 ? 'Pagado' : 'No pagado'}}</b-badge></b-dropdown-item>
          <b-dropdown-item @click="showConfirmUpdate(row.item)"><i class="fa-sharp fa-solid fa-pencil fa-2xs mr-2"></i> Editar</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item v-if="row.item.active" @click="showConfirmDisable(row.item)"><span class="text-danger">Deshabilitar</span></b-dropdown-item>
          <b-dropdown-item v-if="!row.item.active" @click="showConfirmEnable(row.item)"><i class="fa-sharp fa-solid fa-taxi text-success fa-2xs mr-2"></i> <span class="text-success">Habilitar</span></b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-group id="dropdown-group-2" header="Pagos">
            <template v-if="row.item.temporaryVerification == '1'">
              <b-dropdown-item @click="showUpdatePay(row.item)">Retirar verificación provisional</b-dropdown-item>
            </template>
            <template v-else>
              <b-dropdown-item @click="showConfirmPay(row.item)">Verificación temporal</b-dropdown-item>
            </template>
          </b-dropdown-group>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-group id="dropdown-group-3" header="Evidencia" v-if="!row.item.active">
            <b-dropdown-item @click="showEvidence(row.item)">Visualizar evidencia</b-dropdown-item>
          </b-dropdown-group>
        </b-dropdown>
        <!--
        <b-button class="btn-sm" v-if="row.item.status === 1" style="margin-left: 5px" variant="outline-warning" @click="redirectToSuspend(row.item)">Suspender</b-button>
        <b-button class="btn-sm" v-if="row.item.status === 0" style="margin-left: 5px" variant="outline-success" @click="removeSuspension(row.item)">Remover suspensión</b-button>
        <b-button class="btn-sm" v-if="row.item.status === 0" style="margin-left: 5px" variant="outline-success" @click="getInfoAdvice(row.item)">Ver información de suspensión</b-button>-->
        <!--<b-button class="btn-sm" variant="outline-success" @click="validateCheckIn(row.item)">checkIn</b-button>-->
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div>
      <b-modal
        ok-only
        id="modal-prevent-closing-motivos"
        ref="modal"
        title="Motivos de Baja"
        @hidden="hideModal"
      >
        <b-table
          show-empty
          stacked="md"
          :items="disabledConcesion"
          :fields="fieldsMotivos"
          :per-page="1"
        >
          <template v-slot:cell(acciones)="row">
            <b-button class="btn-sm" v-if="!row.item.active" variant="outline-success" @click="viewEvidence(row.item.fileUrl)">Evidencia</b-button>
          </template>
        </b-table>
      </b-modal>
    </div>
    <div class="text-center" v-if="$apollo.queries.getAllConceciones.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>

<script>
// import { encrypt } from '@/config/headers'
import gql from 'graphql-tag'
import { Modal } from 'ant-design-vue'
import headers from '@/config/headers.js'
const ACTIVE_TAXI_CHECKIN_BY_LICENSE_QUERY = gql`
  query getActiveTaxiCheckInByLicensePlate($licensePlate: String) {
    getActiveTaxiCheckInByLicensePlate(licensePlate: $licensePlate){
      id
      date
      checkInTime
      checkOutTime
      status
      concesion{
        id
        concesionNumber
        active
      }
      driver{
        id
        firstName
        lastName
      }
    }
  }
`
const GET_EVIDENCE = gql`
  query getNewestBanByConcesionId($concesionId: Int){
    getNewestBanByConcesionId(concesionId: $concesionId){
      id
      reason
      fileUrl
      createdBy
      concesion{
        id
        concesionNumber
      }
    }
  }
`
const REMOVE_SUSPENSION = gql`
  mutation concesionActivatedService($concesionId: Int){
    concesionActivatedService(concesionId: $concesionId){
      id
      concesionarioId
    }
  }
`
const GET_INFO_ADVICE = gql`
  query getInfoAdvice($rfc: String, $concesionNumber: String){
    getInfoAdvice(rfc: $rfc, concesionNumber: $concesionNumber){
      razon
      autorizedBy
      requestedBy
      fechaFin
      fechaInicio
      createdAt
      concesionNumber
      active
      updatedAt
      fileUrl
      periodoRetorno
    }
  }
`
const ACTIVATE_PAID_CONCESION = gql`
  mutation activatePaidConcesion($concesionNumber: String) {
    activatePaidConcesion(concesionNumber: $concesionNumber) {
      message
      __typename
    }
  }
`
export default {
  data() {
    return {
      fields: [
        // { key: 'id', label: 'Id ', sortable: true, sortDirection: 'desc' },
        // { key: 'paidOut', label: 'Pagado' },
        { key: 'concesionNumber', label: '# Concesión' },
        { key: 'concesionario.rfc', label: 'RFC' },
        { key: 'concesionario.name', label: 'Concesionario' },
        { key: 'vehicle.brand', label: 'Marca' },
        // { key: 'vehicle.model', label: 'Modelo' },
        { key: 'vehicle.licensePlate', label: 'Placas' },
        // 'geocerca',
        { key: 'active', label: 'Pago' },
        { key: 'acciones', label: ' ' },
      ],
      fieldsMotivos: [
        { key: 'reason', label: 'Motivo', sortable: true, sortDirection: 'desc' },
        { key: 'concesion.concesionNumber', label: 'Número de Concesión' },
        { key: 'createdBy', label: 'Deshabilitado por:' },
        { key: 'acciones', label: 'Acciones' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      disabledConcesion: null,
      sortDirection: 'asc',
      filter: null,
      idConcesionAction: null,
      // getAllGeofencesNames: {},
    }
  },
  apollo: {
    getAllConceciones: {
      query: gql`query getAllConceciones{
          getAllConceciones{
            id
            concesionNumber
            geofenceId
            concesionario{
              id
              name
              rfc
            }
            vehicle{
              id
              brand
              serialNumber
              licensePlate
              model
            }
            active
            paidOut
            geofenceId
            status
            temporaryVerification
            siteId
          }
        }`,
      context: headers(),
      error (erro) {
        console.log('Ocurrió un error')
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getAllConceciones) {
          // this.getAllConceciones.forEach(concesion => {
          // concesion.geocerca = this.getAllGeofencesNames[concesion.geofenceId]
          // })
          this.totalRows = data.getAllConceciones.length
        }
      },
    },
  },
  methods: {
    hideModal() {
      this.$refs.modal.hide()
    },
    viewEvidence(fileUrl) {
      window.open(fileUrl)
    },
    showEvidence(concesion) {
      this.$apollo.query({
        query: GET_EVIDENCE,
        context: headers(),
        variables: {
          concesionId: parseInt(concesion.id),
        },
      })
        .then(({ data }) => {
          // console.log(data)
          this.disabledConcesion = [data.getNewestBanByConcesionId]
          this.$refs.modal.show()
          /*
          Modal.confirm({
            title: `Concesión ${data.getNewestBanByConcesionId.concesion.concesionNumber} deshabilitada razón: ${data.getNewestBanByConcesionId.reason} `,
            okText: 'Ver evidencia',
            cancelText: 'Cancelar',
            onOk() {
              window.open(data.getNewestBanByConcesionId.fileUrl)
            },
            onCancel() {
            },
          })  */
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInfoAdvice(concesion) {
      this.$apollo.query({
        query: GET_INFO_ADVICE,
        context: headers(),
        variables: {
          rfc: concesion.concesionario.rfc,
          concesionNumber: String(concesion.concesionNumber),
        },
      })
        .then(({ data }) => {
          if (data.getInfoAdvice.length) {
            Modal.confirm({
              title: `Concesión ${data.getInfoAdvice[0].concesionNumber} suspendida razón: ${data.getInfoAdvice[0].razon} fecha de inicio ${data.getInfoAdvice[0].fechaInicio} fecha de fin ${data.getInfoAdvice[0].fechaFin}`,
              okText: 'Ver evidencia',
              cancelText: 'Cancelar',
              onOk() {
                window.open(data.getInfoAdvice[0].fileUrl)
              },
              onCancel() {
              },
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    removeSuspension(concesion) {
      this.$apollo.mutate({
        mutation: REMOVE_SUSPENSION,
        context: headers(),
        variables: {
          concesionId: parseInt(concesion.id),
        },
      })
        .then(({ data }) => {
          console.log(data)
          this.$apollo.queries.getAllConceciones.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    redirectToSuspend(concesion) {
      this.$router.push({ name: 'suspenderConcesion', params: concesion })
    },
    validateCheckIn(concesion) {
      if (concesion.vehicle) {
        this.$apollo.query({ query: ACTIVE_TAXI_CHECKIN_BY_LICENSE_QUERY, context: headers(), variables: { licensePlate: concesion.vehicle.licensePlate } })
          .then(({ data }) => {
            console.log(data)
            if (data.getActiveTaxiCheckInByLicensePlate === null) {
              // this.handleSubmitDeactivate({ id: concesion.id })
              this.$router.push({ name: 'disableConcesion', params: concesion })
            } else {
              this.showConfirm()
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        // this.handleSubmitDeactivate({ id: concesion.id })
        this.$router.push({ name: 'disableConcesion', params: concesion })
      }
    },
    showConfirmUpdate(concesion) {
      console.log(concesion, 'params')
      Modal.confirm({
        title: 'Confirmar',
        content: '¿Estás seguro(a) que deseas editar la concesión?',
        okText: 'Aceptar',
        okType: 'Cancelar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.validateEditCheckIn(concesion)
        },
        onCancel() {
        },
      })
    },
    showConfirmPay(concesion) {
      Modal.confirm({
        title: 'Confirmar',
        content: '¿Estás seguro(a) que deseas verificar el pago?',
        okText: 'Aceptar',
        okType: 'Cancelar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.validatePay(concesion)
        },
        onCancel() {
        },
      })
    },
    validatePay(concesion) {
      this.$router.push({ name: 'postPayments', params: concesion })
    },
    showUpdatePay(concesion) {
      Modal.confirm({
        title: 'Confirmar',
        content: '¿Estás seguro(a) que deseas quitar la verificación provisional?',
        okText: 'Aceptar',
        okType: 'Cancelar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.updatePay(concesion)
        },
        onCancel() {
        },
      })
    },
    updatePay(concesion) {
      this.$router.push({ name: 'updatePayments', params: concesion })
    },
    showConfirmPayment(concesion) {
      Modal.confirm({
        title: 'Confirmar',
        context: 'Recuerda que esto aprobará todos los pagos pendientes, en el caso que no se vean reflejados se desactivará la cuenta de nuevo.',
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.confirmPay(concesion)
        },
        onCancel() {

        },
      })
    },
    confirmPay(concesion) {
      this.$apollo.mutate({ mutation: ACTIVATE_PAID_CONCESION, context: headers(), variables: { concesionNumber: concesion.concesionNumber } })
        .then(({ data }) => {
          this.$apollo.queries.getAllConceciones.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    validateEditCheckIn(concesion) {
      if (concesion.vehicle) {
        this.$apollo.query({ query: ACTIVE_TAXI_CHECKIN_BY_LICENSE_QUERY, context: headers(), variables: { licensePlate: concesion.vehicle.licensePlate } })
          .then(({ data }) => {
            // console.log(data)
            if (data.getActiveTaxiCheckInByLicensePlate === null) {
              this.$router.push({ name: 'updateConcesion', params: concesion })
            } else {
              this.showConfirmEdit()
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'updateConcesion', params: concesion })
      }
    },
    showConfirmEdit() {
      Modal.info({
        title: 'Esta concesión no se puede editar debido a que el vehículo que esta asignado a esta concesión está vinculado con un conductor que tiene un check in activo',
        okText: 'Aceptar',
        cancelText: 'No',
        onOk() {},
      })
    },
    showConfirmDisable(concesion) {
      Modal.confirm({
        title: 'Confirmar',
        content: '¿Estás seguro(a) que deseas deshabilitar la concesión?',
        okText: 'Aceptar',
        okType: 'Cancelar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.validateCheckIn(concesion)
        },
        onCancel() {
        },
      })
    },
    showConfirmEnable(concesion) {
      Modal.confirm({
        title: 'Confirmar',
        content: '¿Estás seguro(a) que deseas habilitar la concesión?',
        okText: 'Aceptar',
        okType: 'Cancelar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.handleSubmitActivate({ id: concesion.id })
        },
        onCancel() {
        },
      })
    },
    showConfirm() {
      Modal.info({
        title: 'Esta concesión no se puede deshabilitar debido a que el vehículo que esta asignado a esta concesión está vinculado con un conductor que tiene un check in activo',
        okText: 'Aceptar',
        cancelText: 'No',
        onOk() {},
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async handleSubmitDeactivate(id) {
      this.idConcesionAction = id.id
      await this.$apollo.mutate({
        mutation: gql`mutation ($idDelete: Int) {
         deleteConcesion(id:$idDelete){
          id
          concesionNumber
        }
        }`,
        context: headers(),
        variables: {
          idDelete: parseInt(this.idConcesionAction),
        },
      })
        .then(res => {
          this.$apollo.queries.getAllConceciones.refetch()
          // this.getConcesionarios = this.getConcesionarios.filter(item => item.id !== parseInt(this.idDelete))
        })
        .catch(error => {
          this.error = error.message
          console.log(error)
        })
    },
    async handleSubmitActivate(id) {
      this.idConcesionAction = id.id
      await this.$apollo.mutate({
        mutation: gql`mutation activateConcesion($idAdd: Int) {
         activateConcesion(id:$idAdd){
          message
        }
        }`,
        context: headers(),
        variables: {
          idAdd: parseInt(this.idConcesionAction),
        },
      })
        .then(res => {
          this.$apollo.queries.getAllConceciones.refetch()
          // this.getConcesionarios = this.getConcesionarios.filter(item => item.id !== parseInt(this.idDelete))
        })
        .catch(error => {
          this.error = error.message
          console.log(error)
        })
    },
  },
}
</script>

<style>

</style>
